<template>
    <div class="page">
        <div class="btn">
            <van-button size="small" plain type="info" @click="onInit">同施工位置相关项目</van-button>
            <van-popup class="popup" v-model="show" position="right">
                <div class="navbar">
                    <div class="navbar-title">同施工位置相关项目</div>
                    <van-icon @click="show = false" class="navbar-arrow" name="arrow-left" />
                </div>
                <van-list class="list-box" v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
                    <div class="item-box">
                        <div class="item-line">
                            <div class="line-left">施工位置</div>
                            <div class="line-right">{{ locationHead.locationName || "-" }}</div>
                        </div>
                        <div class="item-line">
                            <div class="line-left">归属园区</div>
                            <div class="line-right">{{ locationHead.projectName || "-" }}</div>
                        </div>
                        <div class="item-line">
                            <div class="line-left">项目启动时间</div>
                            <div class="line-right">{{ locationHead.applyStartTime || "-" }}</div>
                        </div>
                        <div class="item-line">
                            <div class="line-left">距上次施工完成间隔天数</div>
                            <div class="line-right">
                                {{ locationHead.intervalDays }}
                                <span v-if="locationHead.intervalDays != null">天</span>
                                <span v-else>-</span>
                            </div>
                        </div>
                    </div>
                    <div class="item-box" v-for="(item, index) in tableData" :key="index">
                        <div class="item-line">
                            <div class="line-left">项目类型</div>
                            <div class="line-right">{{ item.workProjectTypeName || "-" }}</div>
                        </div>
                        <div class="item-line">
                            <div class="line-left">创建时间</div>
                            <div class="line-right">{{ item.addDt || "-" }}</div>
                        </div>
                        <div class="item-line">
                            <div class="line-left">项目编号</div>
                            <div class="line-right">{{ item.projectCode || "-" }}</div>
                        </div>
                        <div class="item-line">
                            <div class="line-left">项目名称</div>
                            <div class="line-right">{{ item.projectInstanceName || "-" }}</div>
                        </div>
                        <div class="item-line">
                            <div class="line-left">归属园区</div>
                            <div class="line-right">{{ item.projectName || "-" }}</div>
                        </div>
                        <div class="item-line">
                            <div class="line-left">归属园区</div>
                            <div class="line-right">
                                <template
                                    v-if="item.workManageProjectInstanceVos && item.workManageProjectInstanceVos.length > 0">
                                    <p v-for="(it, ind) in item.workManageProjectInstanceVos" :key="ind">
                                        <span>{{ businessChargeObj[it.businessCharge] }}施工单位：</span>
                                        <span>{{ it.manageName }}</span>
                                    </p>
                                </template>
                                <template v-else>
                                    <span>-</span>
                                </template>
                            </div>
                        </div>
                        <div class="item-line">
                            <div class="line-left">发起人</div>
                            <div class="line-right">{{ item.applyUserName || "-" }}</div>
                        </div>
                        <div class="item-line">
                            <div class="line-left">启动时间</div>
                            <div class="line-right">{{ item.applyStartTime || "-" }}</div>
                        </div>
                        <div class="item-line">
                            <div class="line-left">项目状态</div>
                            <div class="line-right">{{ item.projectStatusName || "-" }}</div>
                        </div>
                        <div class="item-line">
                            <div class="line-left">项目进度</div>
                            <div class="line-right">{{ item.projectScheduleName || "-" }}</div>
                        </div>
                        <div class="item-line">
                            <div class="line-left">工单审批状态</div>
                            <div class="line-right">{{ item.approveStatusName || "-" }}</div>
                        </div>
                        <div class="item-line">
                            <div class="line-left">当前审批或办理人</div>
                            <div class="line-right">{{ item.approveEmpName || "-" }}</div>
                        </div>
                        <div class="item-line">
                            <div class="line-left">负责人</div>
                            <div class="line-right">{{ item.chargeUser || "-" }}</div>
                        </div>
                        <div class="item-line">
                            <div class="line-left">验收完成的时间</div>
                            <div class="line-right">{{ item.acceptTime || "-" }}</div>
                        </div>
                    </div>
                    <!-- 文本展示区 -->
                </van-list>
            </van-popup>
        </div>
    </div>
</template>

<script>
import { getLocationHead, getLocationPage } from "@/api/task/task";
export default {
    props: ['projectInstanceId'],
    data() {
        return {
            show: false,
            // table表格
            tableData: [],
            loading: false,
            finished: false,
            tableParams: {
                page: 1,
                limit: 10,
                projectInstanceId: this.projectInstanceId
            },
            locationHead: "",
            businessChargeObj: {
                1: "装饰",
                2: "空调",
                3: "消防",
            }
        }
    },
    methods: {
        // 【监听】点击按钮
        onInit() {
            this.getLocationHead();
            this.getRoomList();
            this.show = true;
        },

        // 【请求】相同位置的项目表头
        getLocationHead() {
            let data = this.tableParams;
            getLocationHead(data).then((res) => {
                if (res.success && res.data) {
                    this.locationHead = res.data;
                }
            });
        },

        // 【请求】相同位置的项目列表
        getRoomList() {
            let data = this.tableParams;
            getLocationPage(data).then((res) => {
                if (res.success && res.data.list) {
                    this.tableData = [...this.tableData, ...res.data.list];
                    this.loading = false;
                    if (this.tableData.length >= res.data.total) {
                        this.finished = true;
                    }
                } else {
                    this.loading = false;
                    this.finished = true;
                }
            });
        },

        // 【请求】下拉加载
        onLoad() {
            this.tableParams.page++;
            this.getRoomList();
        },
    }
};
</script>
<style lang="scss" scoped>
.btn {
    padding: 0.1rem;
    background-color: white;
    margin-bottom: .15rem;
}

.popup {
    width: 100%;
    height: 100%;
    background-color: #F1F2F6;
}

.navbar {
    color: white;
    background: #1989fa;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    height: .46rem;
}

.navbar-title {
    font-size: .16rerm;
}

.navbar-arrow {
    position: absolute;
    top: .15rem;
    left: .15rem;
    font-size: .18rem;
}

.list-box {
    height: calc(100% - .46rem);
    overflow-y: auto;
}

.item-box {
    background-color: white;
    border-radius: .1rem;
    margin: .1rem;
    padding: .1rem;
}

.item-line {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: .14rem;
    margin: .1rem 0;
}
</style>